
import { useState } from 'react';

export default function Testimonials() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      name: 'Dana D.',
      location: 'Google Review',
      rating: 5,
      text: 'Young Guns is the real deal! My mom, who\'s 85 and has been dealing with critters in her house forever, called them, and James swooped in like the hero we didn\'t know we needed. Within five minutes of setting his magical traps—BAM!—he caught a critter while he was still working the house. And just when we thought the show was over, another trap went off right after he left, and James did the ultimate superhero move: he turned right around and came back to collect another one! It\'s like watching a Marvel movie, but with fewer explosions and more critter-catching. My mom is finally feeling a bit of peace, and we\'ve officially dubbed James our family\'s super exterminator. If I could give Young Guns more than 5 stars, I\'d give them an entire constellation. Thank you, James, for saving the day—and the house!',
      date: '1 week ago'
    },
    {
      name: 'Linda S.',
      location: 'Google Review',
      rating: 5,
      text: 'James has provided excellent service each time critters got in my attic: squirrels the first time and a raccoon the second. He made several trips each time, locating the access points, setting traps for their removal. Finally he closed up the access points for 100 percent success. I highly recommend James and Young Gun Pest Control for all pest removal!',
      date: '2 weeks ago'
    },
    {
      name: 'Carol A.',
      location: 'Google Review',
      rating: 5,
      text: 'James Stricklin from Young Guns Pest Control went above and beyond to take care of our complicated pest plus critters problem. He was efficient, competent, professional and always showed up when he said he would. Extremely knowledgeable about the pests and critters. Awesome service. Highly recommend.',
      date: '3 weeks ago'
    },
    {
      name: 'Carol S.',
      location: 'Google Review',
      rating: 5,
      text: 'James came out to my house last week, to do pest control, ants and other yard and house pests. He came back by today and check to make sure there were no more signs or problems. Both times he was very courteous, thorough, and knowledgeable. James made sure I understood what he was using on house and yard. He checked to see if I had any more questions. He was right on time for the scheduled appointments. Felt confident enough that I went ahead and got on a quarterly plan for him to come out and treat the house, so hopefully it will keep the pests away for good.',
      date: '1 month ago'
    },
    {
      name: 'Doug S.',
      location: 'Google Review',
      rating: 5,
      text: 'Jimmy is professional all the way. Had Squirrels in my attic, he found multiple entry/exit points. Closed all holes and got all rodents out. Took a couple of trips but Jimmy stayed diligent. Have not seen nor heard any signs of squirrels since.',
      date: '1 month ago'
    },
    {
      name: 'Raymond C.',
      location: 'Google Review',
      rating: 5,
      text: 'James at Young Guns Pest Control is a true professional and I am so glad we have him taking care of our pest needs. More recently he came to our aid, didn\'t quit when it would be easy for him to do so; however, he worked over several days to get the job done! I highly recommend James at Young Guns Pest Control!',
      date: '2 months ago'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Customer Reviews
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            See what our customers are saying about our pest control services.
          </p>
        </div>

        {/* Google Rating Display */}
        <div className="bg-gray-700 rounded-2xl p-8 shadow-lg mb-12 max-w-4xl mx-auto border border-gray-600">
          <div className="text-center">
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center mr-4">
                <i className="ri-google-fill text-5xl text-red-500"></i>
              </div>
              <div>
                <h3 className="text-3xl font-bold text-white">Google Reviews</h3>
                <p className="text-gray-300">Verified Customer Feedback</p>
              </div>
            </div>
            
            <div className="flex items-center justify-center mb-8">
              <span className="text-6xl font-bold text-white mr-6">4.6</span>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-8 h-8 flex items-center justify-center mr-1">
                      <i className="ri-star-fill text-yellow-400 text-3xl"></i>
                    </div>
                  ))}
                </div>
                <p className="text-lg text-gray-300 font-semibold">Based on 50+ Reviews</p>
              </div>
            </div>
            
            <a 
              href="https://maps.app.goo.gl/vr9zge9jjbfymyfua" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition-colors cursor-pointer text-lg whitespace-nowrap"
            >
              <div className="w-6 h-6 flex items-center justify-center mr-3">
                <i className="ri-external-link-line text-xl"></i>
              </div>
              Read All Reviews on Google
            </a>
          </div>
        </div>

        {/* Customer Reviews Carousel */}
        <div className="relative max-w-5xl mx-auto">
          <div className="bg-gray-700 rounded-2xl p-8 md:p-12 shadow-lg border border-gray-600">
            <div className="text-center">
              {/* Review Header */}
              <div className="flex items-center justify-between mb-8">
                <div className="flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center mr-3">
                    <i className="ri-google-fill text-2xl text-red-500"></i>
                  </div>
                  <span className="text-lg font-semibold text-gray-300">Customer Review</span>
                </div>
                <span className="text-sm text-gray-400">{testimonials[currentTestimonial].date}</span>
              </div>

              <div className="flex justify-center mb-8">
                {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                  <div key={i} className="w-8 h-8 flex items-center justify-center mr-1">
                    <i className="ri-star-fill text-yellow-400 text-2xl"></i>
                  </div>
                ))}
              </div>
              
              <blockquote className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed max-w-4xl mx-auto">
                "{testimonials[currentTestimonial].text}"
              </blockquote>
              
              <div className="flex flex-col items-center">
                <h4 className="text-xl font-bold text-white mb-1">
                  {testimonials[currentTestimonial].name}
                </h4>
                <p className="text-gray-300">{testimonials[currentTestimonial].location}</p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <button
            onClick={prevTestimonial}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-gray-700 rounded-full shadow-lg hover:bg-gray-600 transition-colors cursor-pointer border border-gray-600"
          >
            <i className="ri-arrow-left-line text-xl text-white"></i>
          </button>
          
          <button
            onClick={nextTestimonial}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-gray-700 rounded-full shadow-lg hover:bg-gray-600 transition-colors cursor-pointer border border-gray-600"
          >
            <i className="ri-arrow-right-line text-xl text-white"></i>
          </button>

          {/* Dots */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  index === currentTestimonial ? 'bg-green-500' : 'bg-gray-600'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
